import { render } from "./postData.vue?vue&type=template&id=45476e15"
import script from "./postData.vue?vue&type=script&lang=js"
export * from "./postData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__